// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React, { useEffect, useState } from 'react'
import { Notification } from 'grommet-icons'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box } from 'grommet'
import { useReactOidc } from '@axa-fr/react-oidc-context'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useVisibilityContext } from '../../../context/visibility-context'
import { Button } from '../../../components'
import { isCoP, getCustomerAccount } from '../../../utils/feature-flag-utils'
import useFetchIsCCSManager from '../../../hooks/ccs-manager/useFetchIsCCSManager'

import { BellNotificationIcon } from './icon'
import { handleBellIconClick, startPolling } from './utils'

const BellNewNotification = () => {
  const { t } = useTranslation(['manage'])
  const [hasNew, setHasNew] = useState(false)
  const [trigger, setTrigger] = useState(false)
  const { oidcUser } = useReactOidc()
  const navigate = useNavigate()
  const LDFlags = useFlags()
  const [showNotification, setShowNotification] = useState(null)
  const { rbacPolicies } = useVisibilityContext()
  const { isCCSManager } = useFetchIsCCSManager()
  const custAccountLoaded = getCustomerAccount()
  const notificationsRbac = {
    permission: 'ccs.notification.edit',
    resource: '/ccs/notification'
  }

  useEffect(() => {
    return startPolling({
      oidcUser,
      custAccountLoaded,
      LDFlags,
      setHasNew
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger])

  if (!isCoP()) {
    return (
      <>
        {showNotification}
        {hasNew && !isCCSManager ? (
          <Box>
            <Button
              default
              icon={<BellNotificationIcon />}
              onClick={() =>
                handleBellIconClick({
                  trigger,
                  setTrigger,
                  rbacPolicies,
                  notificationsRbac,
                  isCCSManager,
                  setShowNotification,
                  navigate,
                  t
                })
              }
              testId="bell-notification-red-dot"
            />
          </Box>
        ) : (
          <Box>
            <Button
              default
              icon={<Notification color="text" />}
              onClick={() =>
                handleBellIconClick({
                  trigger,
                  setTrigger,
                  rbacPolicies,
                  notificationsRbac,
                  isCCSManager,
                  setShowNotification,
                  navigate,
                  t
                })
              }
              testId="bell-notification"
            />
          </Box>
        )}
      </>
    )
  }
  return null
}
export { BellNewNotification }
